import { patchPersona, track } from '@sloyd/analytics';
import { prompt, SignupForm, toast } from '@sloyd/ui';
import { delay, fork, takeEvery } from 'saga-ts';
import { getBoolean, invokeEvent, l, setBoolean } from 'shared-base';
import { dataGuard } from './helpers/guards';

const SPECIAL_OFFER_ENABLED = true;

export const saga = {
  id: 'sloyd.onboarding',
  type: 'entity',
  root: root,
  trigger: {
    actionTypes: ['ONBOARDING'],
  },
};

type Verb =
  | 'show' //
  | 'special';

type Action = {
  type: 'ONBOARDING';
  verb: Verb;
  id: string;
  payload: Json;
};

const map: Record<Verb, any> = {
  show: show,
  special: special,
};

const analyitcsMap: any = {
  show: 'Show Onboarding',
};

export function* special(_action: Action) {
  try {
    if (!SPECIAL_OFFER_ENABLED) return;
    const wasShown = getBoolean('specialOfferShown');

    if (wasShown) {
      console.log('special offer already shown');
      return;
    }

    yield delay(100);

    setBoolean('specialOfferShown', true);

    invokeEvent('nav', { path: '/special' });
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

export function* show(_action: Action) {
  try {
    const wasShown = getBoolean('onboarding');

    if (wasShown) {
      console.log('onboarding already shown');
      return;
    }

    yield delay(2000);

    track('Show Signup Form');

    const { value, didCancel } = yield prompt.custom({
      title: 'Adjust your experience',
      component: SignupForm,
      componentProps: {},
    });

    setBoolean('onboarding', true);

    if (!value || didCancel) {
      track('Dismissed Signup Form');
      return;
    }

    if (value.persona === 'Company') {
      const { valueCompany } = yield prompt.input({
        title: 'Company Name',
        placeholder: 'Company Name',
        ctaButtonText: 'Submit',
      });

      if (valueCompany) {
        patchPersona({ company: valueCompany });
        track('Company', { company: valueCompany });
      }
    }

    track('Submitted Signup Form', value);
    patchPersona(value);

    toast.show('Thank you for sharing your preferences');
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

export function* onBoarding(action: any) {
  const { verb, id, origin } = action;
  yield delay(10);

  const saga = (map as any)[verb];

  if (!saga) {
    return;
  }

  l(`saga|saga.onboarding ${verb} on ${id}`);

  yield* dataGuard();

  track(analyitcsMap[verb], { origin, id });

  yield* fork(saga, action);
}

export function* root() {
  yield takeEvery('ONBOARDING', onBoarding);
}
